<template>
  <span
    class="inline-block size-4 animate-spin rounded-full border-2 border-[var(--ax-color-border)] border-t-[var(--ax-color-primary)]"
    role="status"
    aria-label="Loading"
  />
</template>
